import { Col, Typography, Button } from "antd";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import { QualificationStatusBadge } from "../../../../shared/components/ui/AcademyStatusBadge";
import { ProgramStudentModuleTechniqueType } from "../../../../types/dto/program";
import Table from "../../../../shared/components/ui/Table/prueba";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import React from "react";
import { WrapperModalQualificationStudent } from "../styled";
import EditStudentQualification from "./EditStudentQualification";
import { programsStudentModuleTechniqueAcademy } from "../../../../shared/services";
import { useParams } from "react-router-dom";
import useDeleteQualificationStudent from "../../hooks/qualifications/useDeleteQualificationStudent";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../redux";

const { Text } = Typography;

const getQualificationLabel = (item: ProgramStudentModuleTechniqueType) => {
  const techniqueName = item.program_module_technique?.name;
  if (techniqueName) return techniqueName;

  const topicName =
    item.program_module_technique?.program_module_topic?.name ??
    item.program_module_topic?.name;
  if (topicName) return topicName;

  return `Registro #${item.id}`;
};

const renderNestedText = (value: unknown) => (
  <Text className="text-xs text-gray-500">{value ? String(value) : "—"}</Text>
);

export const TableListProgramQualification = ({
  onTableReady,
}: {
  onTableReady?: (refresh: () => void) => void;
} = {}) => {
  const {user_id} = useParams()
  const user = useSelector(selectUser);
  const refreshTableRef = React.useRef<(() => void) | null>(null);
    const [openModalEditQualification, setOpenModalEditQualification] =
      React.useState<boolean>(false);
    const [techeniqueId, setTecheniqueId] = React.useState<number>();

    const refreshTable = React.useCallback(() => {
      refreshTableRef.current?.();
    }, []);

    const { showDeleteConfirm } = useDeleteQualificationStudent({
      onSuccess: refreshTable,
    });

    const canManageQualifications =
      !!user?.role &&
      ["teacher", "teacher_admin", "admin"].includes(user.role);
  
    const handleOpemModalEdit = (value: number) => {
      setTecheniqueId(value);
      setOpenModalEditQualification(true);
    };
    
    const columns: TableColumns<ProgramStudentModuleTechniqueType> = [
      {
        title: "ID",
        dataIndex: "id",
        width: 3,
        key: "id",
        filterType: "filterByID",
      },
      {
        title: "Programa",
        width: 5,
        key: "program_name",
        render: (_, item) =>
          renderNestedText(
            item.program_module_technique?.program_module_topic?.program_module
              ?.program?.name
          ),
      },
      {
        title: "Modulos",
        width: 5,
        key: "module_name",
        render: (_, item) =>
          renderNestedText(
            item.program_module_technique?.program_module_topic?.program_module
              ?.name
          ),
      },
      {
        title: "Tema",
        width: 5,
        key: "topic_name",
        render: (_, item) =>
          renderNestedText(
            item.program_module_technique?.program_module_topic?.name
          ),
      },
      {
        title: "Tecnica",
        width: 5,
        key: "technique_name",
        render: (_, item) =>
          renderNestedText(item.program_module_technique?.name),
      },
      {
        title: "Calificación estado",
        width: 5,
        dataIndex: "qualification_check",
        key: "qualification_check",
        render: (_, item) => (
          <Col
            style={{
              display: "flex",
              width: "100%",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <QualificationStatusBadge status={item.qualification_check} />
          </Col>
        ),
      },
      {
        title: "Calificación",
        width: 5,
        dataIndex: "qualification",
        key: "qualification",
        render: (_, item) => {
      
          return (
            <Col
              style={{
                display: "flex",
                width: "100%",
                flexDirection: "row",
                justifyContent:'center'
              }}
            >
              <Text >
                {item.qualification}
              </Text>
            </Col>
          );
        },
      },
      {
        title: "Acciones",
        key: "operation",
        width: 5,
        fixed: "right",
        render: (_, item) => {
          if (!canManageQualifications) return null;

          return (
            <Col
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                gap: 15,
              }}
            >
              <Button
                type="primary"
                shape="circle"
                icon={<EditOutlined />}
                size="large"
                onClick={() => handleOpemModalEdit(item.id)}
              />
              <Button
                type="primary"
                danger
                shape="circle"
                icon={<DeleteOutlined />}
                size="large"
                onClick={() =>
                  showDeleteConfirm(item.id, getQualificationLabel(item))
                }
              />
            </Col>
          );
        },
      },
    ];

    return (
      <>
        <WrapperModalQualificationStudent
          title={`Editar calificacion del estudiante`}
          open={openModalEditQualification}
          width={"320px"}
          destroyOnClose
          onClose={() => setOpenModalEditQualification(false)}
        >
          <EditStudentQualification
            setOpenModal={setOpenModalEditQualification}
            techeniqueId={+techeniqueId!}
            onSuccess={refreshTable}
          />
        </WrapperModalQualificationStudent>
        <Table<ProgramStudentModuleTechniqueType>
          columns={columns}
          fetchQueryProps={{
            user_id: +user_id!,
            $sort: { id: -1 },
          }}
          onLoad={({ refresh }) => {
            refreshTableRef.current = refresh;
            onTableReady?.(refresh);
          }}
          service={programsStudentModuleTechniqueAcademy}
        />
      </>
    );
  };
